"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactInfiniteScrollComponent = _interopRequireDefault(require("react-infinite-scroll-component"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loading = _interopRequireDefault(require("../../../Loading"));

var _StyledLayout = require("../../../StyledLayout");

var _StyledTypography = require("../../../StyledTypography");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RenderDropdownOptions = function RenderDropdownOptions(_ref) {
  var builtOptions = _ref.builtOptions,
      name = _ref.name,
      matchIndex = _ref.matchIndex,
      scrollToSelection = _ref.scrollToSelection,
      show = _ref.show,
      optionHeightForScrollTo = _ref.optionHeightForScrollTo;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      renderSlice = _useState2[0],
      setRenderSlice = _useState2[1];

  var init = (0, _react.useRef)({
    isSelectionScrolledTo: false
  });
  (0, _react.useEffect)(function () {
    // when drop down is shown, set renderSlice to include the user's selected option's index
    if (show) {
      if (scrollToSelection && matchIndex) {
        setRenderSlice(matchIndex + 12);
      } else setRenderSlice(24); // set isSelectionScrolledTo to false on show to ensure the auto-scroll happens


      init.current.isSelectionScrolledTo = false;
    }
  }, [show]);
  (0, _react.useEffect)(function () {
    // scrollToSelection will be false once the dropdown is filtered
    // this will scroll the user to their initial selection after open
    if (scrollToSelection && matchIndex && !init.current.isSelectionScrolledTo) {
      var _document$getElementB;

      init.current.isSelectionScrolledTo = true; // eslint-disable-next-line no-unused-expressions

      (_document$getElementB = document.getElementById("".concat(name, "-dropdown-scroll-id"))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollTo(0, optionHeightForScrollTo * matchIndex);
    }
  }, [renderSlice]);
  (0, _react.useEffect)(function () {
    // if builtOptions length changes, that means there's a new set of options to render
    // then scroll user to top of dropdown for new list
    if (!(scrollToSelection && matchIndex)) {
      if (builtOptions !== null && builtOptions !== void 0 && builtOptions.length) {
        setRenderSlice(builtOptions.length < 24 ? builtOptions.length : 24);
      } else setRenderSlice(null);

      document.getElementById("".concat(name, "-dropdown-scroll-id")).scrollTop = 0;
    }
  }, [builtOptions === null || builtOptions === void 0 ? void 0 : builtOptions.length]);

  var updateRenderSlice = function updateRenderSlice() {
    setRenderSlice(function (prev) {
      return prev + 24;
    });
  };

  return typeof renderSlice === 'number' ? /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_reactInfiniteScrollComponent["default"], {
    dataLength: renderSlice,
    hasMore: builtOptions.length > renderSlice,
    next: updateRenderSlice,
    loading: /*#__PURE__*/_react["default"].createElement(_Loading["default"], null),
    scrollableTarget: "".concat(name, "-dropdown-scroll-id"),
    style: {
      width: '100%'
    }
  }, builtOptions !== null && builtOptions !== void 0 && builtOptions.length ? builtOptions.slice(0, renderSlice) : null)) : /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    mediumGrey: true,
    center: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "forms.dropdown.no_match"
  })));
};

RenderDropdownOptions.defaultProps = {
  matchIndex: null,
  scrollToSelection: false,
  optionHeightForScrollTo: null
};
RenderDropdownOptions.propTypes = {
  builtOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  name: _propTypes["default"].string.isRequired,
  matchIndex: _propTypes["default"].number,
  scrollToSelection: _propTypes["default"].bool,
  show: _propTypes["default"].bool.isRequired,
  optionHeightForScrollTo: _propTypes["default"].number
};
var _default = RenderDropdownOptions;
exports["default"] = _default;